(function (angular, color) {
  "use strict";

  angular.module("Toyota.Factories").factory("PaintListColourMatcher", function () {
    function toNormalizedColourTuples(colourTuples) {
      var normalizedColourTuples = [];
      angular.forEach(colourTuples, function (val) {
        normalizedColourTuples.push({
          description: val.description,
          hex: color(val.hex).toCSSHex(),
          colour: color(val.hex),
        });
      });
      return normalizedColourTuples;
    }

    // Adapted from https://github.com/antimatter15/rgb-lab/blob/master/color.js
    /* eslint-disable no-magic-numbers */

    function rgb2lab(rgb) {
      var r = rgb.red / 255,
        g = rgb.green / 255,
        b = rgb.blue / 255,
        x,
        y,
        z;

      r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
      g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
      b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

      x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
      y = r * 0.2126 + g * 0.7152 + b * 0.0722;
      z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;

      x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
      y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
      z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;

      return {
        l: 116 * y - 16,
        a: 500 * (x - y),
        b: 200 * (y - z),
      };
    }

    /*
     * calculate the perceptual distance between colors in CIELAB
     * https://github.com/THEjoezack/ColorMine/blob/master/ColorMine/ColorSpaces/Comparisons/Cie94Comparison.cs
     */

    function deltaE(labA, labB) {
      var deltaL = labA.l - labB.l;
      var deltaA = labA.a - labB.a;
      var deltaB = labA.b - labB.b;
      var c1 = Math.sqrt(labA.a * labA.a + labA.b * labA.b);
      var c2 = Math.sqrt(labB.a * labB.a + labB.b * labB.b);
      var deltaC = c1 - c2;
      var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
      deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
      var sc = 1.0 + 0.045 * c1;
      var sh = 1.0 + 0.015 * c1;
      var deltaLKlsl = deltaL;
      var deltaCkcsc = deltaC / sc;
      var deltaHkhsh = deltaH / sh;
      var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
      return i < 0 ? 0 : Math.sqrt(i);
    }

    /* eslint-enable no-magic-numbers */

    // end rgb-lab

    function preprocessForMatching(colour) {
      var newColour = colour.toHSV();
      newColour.saturation = 1 - (1 - newColour.saturation) * (1 - newColour.saturation);

      // throttle down saturation again for high luminance
      var luminance = colour.getLuminance();
      var desaturationCoefficient = luminance * luminance * luminance;
      newColour.saturation *= 1 - desaturationCoefficient;
      return newColour.toRGB();
    }

    return function (overrides) {
      var api = {};

      var normalizedColourTuples = [];

      var config = {
        colourTuples: [],
        normalizedColourTuples: [],
      };
      angular.extend(config, overrides);
      config.normalizedColourTuples = normalizedColourTuples = toNormalizedColourTuples(config.colourTuples);

      api.getColourTuples = function () {
        return angular.copy(config.normalizedColourTuples);
      };

      api.exactMatch = function (colourTuple) {
        var newColourTuple = angular.extend({}, colourTuple);
        newColourTuple.colour = color(colourTuple.hex);
        for (var i = 0, colourI; i < normalizedColourTuples.length; i++) {
          colourI = normalizedColourTuples[i];
          if (
            newColourTuple.description === colourI.description &&
            newColourTuple.colour.toCSSHex() === colourI.colour.toCSSHex()
          ) {
            return true;
          }
        }

        return false;
      };

      var COLOUR_DESCRIPTION_DISTANCE_FACTOR = 0.000001;

      api.closestMatch = function (colourTuple, minimumPercentMatch) {
        if (!colourTuple || !colourTuple.hex) {
          return null;
        }

        var colour = color(colourTuple.hex);
        var sortedColours = api.getColourTuples().sort(function (colourTupleA, colourTupleB) {
          var colourDistanceToA = deltaE(
            rgb2lab(preprocessForMatching(colourTupleA.colour)),
            rgb2lab(preprocessForMatching(colour))
          );
          var colourDistanceToB = deltaE(
            rgb2lab(preprocessForMatching(colourTupleB.colour)),
            rgb2lab(preprocessForMatching(colour))
          );
          var descriptionDistanceToA = colourTupleA.description === colourTuple.description ? 0 : 1;
          var descriptionDistanceToB = colourTupleB.description === colourTuple.description ? 0 : 1;
          return (
            (colourDistanceToA - colourDistanceToB) * (1 - COLOUR_DESCRIPTION_DISTANCE_FACTOR) +
            (descriptionDistanceToA - descriptionDistanceToB) * COLOUR_DESCRIPTION_DISTANCE_FACTOR // tie breaker
          );
        });

        var percentMatch = 1 - deltaE(rgb2lab(sortedColours[0].colour), rgb2lab(colour));

        if (typeof minimumPercentMatch === "number") {
          if (percentMatch < minimumPercentMatch) {
            return null;
          }
        }

        return angular.extend({ percentMatch: percentMatch }, sortedColours[0]);
      };

      return api;
    };
  });
  // eslint-disable-next-line no-undef
})(window.angular, window.Color);
